/* eslint-disable class-methods-use-this */
import * as amplitude from '@amplitude/analytics-browser';
import store from 'Src/store';
import { ifProd } from 'Utils/env';
import type { AnalyticsData, AnalyticsStrategy, Primitive } from '../types';

export class AmplitudeProvider<T = Primitive> implements AnalyticsStrategy<T> {
  constructor() {
    const key = ifProd(process.env.PROD_AMPLITUDE_API_KEY, process.env.STAGING_AMPLITUDE_API_KEY);
    const storeState = store.getState();
    if (!key) throw new Error('Amplitude API key not found');

    amplitude.init(key, storeState?.application?.customerId, { autocapture: false });
  }

  sendEvent(eventName: string, data?: AnalyticsData<T>) {
    const NON_EXISTING_CUSTOMER_ID = '0';
    const { customerId = NON_EXISTING_CUSTOMER_ID } = store.getState()?.application ?? {};
    const amplitudeUserId = amplitude.getUserId();
    const userIdAlreadyExists = !!data?.kueski_user_id || customerId !== NON_EXISTING_CUSTOMER_ID;
    if (amplitudeUserId === NON_EXISTING_CUSTOMER_ID && userIdAlreadyExists) {
      const userId = data?.kueski_user_id ?? customerId;
      amplitude.setUserId(userId);
    }
    return amplitude.track(eventName, data).promise;
  }

  getDeviceId() {
    return amplitude.getDeviceId();
  }
}
